import(/* webpackMode: "eager" */ "/home/ngisense/P4D/Parts4Drive/packages/eve-chat/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["CartDrawer"] */ "/home/ngisense/P4D/Parts4Drive/packages/eve-chat/components/cart/CartDrawer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FloatingCartButton"] */ "/home/ngisense/P4D/Parts4Drive/packages/eve-chat/components/cart/FloatingCartButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ngisense/P4D/Parts4Drive/packages/eve-chat/components/GoogleCustomerReviewsBadge.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CartProvider"] */ "/home/ngisense/P4D/Parts4Drive/packages/eve-chat/context/CartContext.tsx");
